export default __webpack_public_path__ + "static/media/Beds and Wardrobes_2.e30fc7b9.jpg";